import * as React from "react";
import styled from "@emotion/styled";
import { STRINGS } from "../strings";
import { translate } from "../translate";

export const ResubmissionBanner = ({ resubmissionReason }: { resubmissionReason: string }) => {
  return (
    <ResubmissionBanner.Root>
      <ResubmissionBanner.Header>
        {translate(STRINGS.RESUBMISSION_BANNER_TITLE)}
      </ResubmissionBanner.Header>
      <ResubmissionBanner.Content>{resubmissionReason}</ResubmissionBanner.Content>
    </ResubmissionBanner.Root>
  );
};

ResubmissionBanner.Root = styled.div`
  background-color: var(--red-soft);
  border-left: 4px solid var(--red);
  padding: 16px;
  margin-bottom: 16px;
  border-radius: 4px;
`;

ResubmissionBanner.Header = styled.h3`
  margin: 0 0 8px 0;
  font-size: 16px;
  font-weight: 600;
  color: var(--gray-700);
`;

ResubmissionBanner.Content = styled.p`
  margin: 0;
  font-size: 14px;
  color: var(--gray-700);
`;
